import { createElement } from 'react';
import { az as Spacer$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var Spacer = function Spacer(props) {
  return /*#__PURE__*/createElement(Spacer$1, __assign({}, props));
};
Spacer.displayName = 'Spacer';

export { Spacer };
